// src/pages/masters/cities/CitiesForm.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import GradientButton from '../../../components/GradientButton/GradientButton';
import CancelButton from '../../../components/CancelButton/CancelButton';
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';

const CitiesForm = ({ initialData = {}, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    id: "",
    department_code: "",
    department_name: "",
    municipal_code: "",
    municipal_name: "",
    type: "",
    longitude: "",
    Latitud: "",
    ...initialData,
  });

  const [modal, setModal] = useState({ open: false, type: "error", title: "", message: "" });


  useEffect(() => {
    setFormData((prev) => ({ ...prev, ...initialData }));
  }, [initialData]);

  const closeModal = () => setModal((prev) => ({ ...prev, open: false }));


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("access_token");

      if (initialData && initialData._id) {
        formData.id = initialData._id;
        await axios.put(
          `${process.env.REACT_APP_API_URL}/city/update/${initialData._id}`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/city/create`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("Error en formulario de ciudad:", err);
      const backendMessage =
        err.response?.data?.errors?.[0] ||
        err.response?.data?.message ||
        "Ocurrió un error inesperado. Intenta nuevamente.";

      setModal({
        open: true,
        type: "error",
        title: "Error al guardar",
        message: backendMessage,
      });
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="bg-white px-6 py-6 rounded-lg shadow-md text-gray-700 font-sans w-full"
      >
        {/* Grid de 2 columnas */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label htmlFor="department_code" className="text-gray-600 mb-1">
              Código del departamento
            </label>
            <input
              type="text"
              name="department_code"
              id="department_code"
              value={formData.department_code}
              onChange={handleChange}
              required
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="department_name" className="text-gray-600 mb-1">
              Nombre del departamento
            </label>
            <input
              type="text"
              name="department_name"
              id="department_name"
              value={formData.department_name}
              onChange={handleChange}
              required
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="municipal_code" className="text-gray-600 mb-1">
              Código del municipio
            </label>
            <input
              type="text"
              name="municipal_code"
              id="municipal_code"
              value={formData.municipal_code}
              onChange={handleChange}
              required
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="municipal_name" className="text-gray-600 mb-1">
              Nombre del municipio
            </label>
            <input
              type="text"
              name="municipal_name"
              id="municipal_name"
              value={formData.municipal_name}
              onChange={handleChange}
              required
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="Latitud" className="text-gray-600 mb-1">
              Latitud
            </label>
            <input
              type="text"
              name="Latitud"
              id="Latitud"
              value={formData.Latitud}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="longitude" className="text-gray-600 mb-1">
              Longitud
            </label>
            <input
              type="text"
              name="longitude"
              id="longitude"
              value={formData.longitude}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="type" className="text-gray-600 mb-1">
              Tipo
            </label>
            <input
              type="text"
              name="type"
              id="type"
              value={formData.type}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          <div className="flex self-end gap-2">
            <GradientButton type="submit">
              {initialData._id ? "Guardar" : "Crear"}
            </GradientButton>
            <CancelButton onClick={onCancel} />
          </div>
        </div>
      </form>
      <ConfirmModal
        isOpen={modal.open}
        type={modal.type}
        title={modal.title}
        message={modal.message}
        confirmText="Aceptar"
        onConfirm={closeModal} // 👈 con type="error" solo se renderiza este botón
      />
    </>
  );
};

export default CitiesForm;
